import Admin, { hasRole, Role } from '@/models/Admin'
import Batch from '@/models/Batch'

export default class BatchPolicy {
	viewAny(_admin: Admin): boolean {
		return true
	}

	view(admin: Admin, batch: Batch) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	update(admin: Admin, batch: Batch) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	restore(admin: Admin, batch: Batch) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	delete(admin: Admin, batch: Batch) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	forceDelete(_admin: Admin, _batch: Batch) {
		return false
	}
}
